import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';

@Service()
export default class LoginService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async Get(
        name: string, enterpriseUnifiedNumber: string, accreditationNumber: string, taxNumber: string, pageIndex: string,
        pageSize: string,
        createdDateFrom: string = '',
        createdDateTo: string = '',
        requestStatus: number = 0,
        sortBy: string = 'createdDate',
        sortDescending: boolean = true,
    ): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const p = new URLSearchParams();
            p.append('name', name || '');
            p.append('enterpriseUnifiedNumber', enterpriseUnifiedNumber || '');
            p.append('accreditationNumber', accreditationNumber || '');
            p.append('taxNumber', taxNumber || '');
            p.append('pageIndex', pageIndex);
            p.append('pageSize', pageSize);
            p.append('sortBy', sortBy);
            p.append('sortDescending', String(sortDescending));
            if (createdDateFrom) {
                p.append('createdDateFrom', createdDateFrom);
            }
            if (createdDateTo) {
                p.append('createdDateTo', createdDateTo);
            }
            if (requestStatus > 0) {
                p.append('requestStatus', String(requestStatus));
            }
            const url = window.$config.HostName + 'api/providerrequest?' + p.toString();
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async approve(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providerrequest/approve?id=' + encodeURIComponent(id);
            const result = await this.axiosService.axiosInstance.put(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async approveBulk(ids: string[]): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providerrequest/approve-bulk';
            const result = await this.axiosService.axiosInstance.put(url, { ids });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async reject(id: string, reason: string): Promise<any> {
        this.loaderService.ShowLoader();
        const request = {
            id,
            rejectionReason: reason,
        };
        try {
            const url = window.$config.HostName + 'api/providerrequest/reject';
            const result = await this.axiosService.axiosInstance.put(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async rejectBulk(ids: string[], reason: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providerrequest/reject-bulk';
            const result = await this.axiosService.axiosInstance.put(url, { ids, rejectionReason: reason });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async GeById(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providerrequest/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data.result;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

}
